export const PROMPT_TRUNCATION_THRESHOLD = 120;

export const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
};

export const RESOLUTION_PATTERNS = {
  "4K": ["4k", "4096"],
  "2K": ["2k", "2048"],
} as const;

export const DEFAULT_RESOLUTION_DISPLAY = "1K";

export const PIPELINE_TYPES = {
  AD: "ad",
  EDIT: "edit",
  DIRECTOR: "director",
  TEXT_TO_VIDEO: "text-to-video",
  FRAMES_TO_VIDEO: "frames-to-video",
} as const;
